import React from "react";
import { List, Typography, Box } from "@mui/material";
import { useTranslations } from "hooks";
import { getTranslation } from "common";
import { Robot } from "hooks/useRobots";
import RobotAssociationItem from "./AssociationComponents/RobotAssociationItem";
import { ExtensionElements } from "model/processModel";

//fatto su modello di AssociationList
const RobotAssociationList: React.FC<{
  listToBeDisplayed: Robot[];
  extensionElements: ExtensionElements | undefined;
  onLaneMouseDown: any;
  selectedLane: string;
  oppAccordianRef: any;
  containerHeight: number;
}> = ({
  listToBeDisplayed,
  extensionElements,
  onLaneMouseDown,
  selectedLane,
  containerHeight,
  oppAccordianRef,
}) => {
  const translations = useTranslations();
  const laneParticipantIds: string[] =
    (extensionElements &&
      selectedLane &&
      extensionElements[selectedLane]?.map(
        (extEl) => `${extEl.idparticipant}-${extEl.idparticipanttype}`
      )) ||
    [];

  return (
    <Box>
      <Typography variant="subtitle1" fontWeight="bold">
        {getTranslation(translations, "robots.name")}
      </Typography>
      <Box
        sx={{
          flexGrow: 1,
          overflowY: "auto",
          maxHeight: containerHeight - 100,
        }}
      >
        <List dense disablePadding>
          {listToBeDisplayed.map((ele) => (
            <RobotAssociationItem
              key={`association-robot-${ele.id}`}
              selected={laneParticipantIds.includes(`${ele.id}-4`)}
              ele={ele}
              onLaneMouseDown={onLaneMouseDown}
              selectedLane={selectedLane}
              ind={ele.id}
            />
          ))}
        </List>
      </Box>
    </Box>
  );
};

export default RobotAssociationList;
